import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 col-grow" }, "Some errors appeared during members profiles update", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-pa-sm",
        style: {"width":"620px","max-width":"80vw"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { avatar: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "warning",
                    color: "primary",
                    size: "lg"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "scroll" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_table, {
                rows: _ctx.response,
                columns: _ctx.responseColumns,
                "row-key": "name",
                style: {"max-height":"400px"},
                "rows-per-page-options": [0],
                "hide-bottom": "",
                flat: ""
              }, null, 8, ["rows", "columns"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "OK",
                onClick: _ctx.onCancelClick,
                color: "primary",
                outline: "",
                "no-caps": "",
                unelevated: ""
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}